// eslint-disable-next-line import/no-default-export
export default [
    {
        label: 'Tenant',
        value: 'tenant'
    },
    {
        label: 'Owner occupier (with mortgage)',
        value: 'owner_with_mortgage'
    },
    {
        label: 'Owner occupier (no mortgage)',
        value: 'owner_no_mortgage'
    },
    {
        label: 'Living rent free (e.g. with parents)',
        value: 'rent_free'
    }
];
